import type {
	Action,
	BoundActions,
	HookActionsFunction,
	HookStateFunction,
} from 'react-sweet-state';
import { createStore, createActionsHook, createStateHook } from 'react-sweet-state';

//**
// This hook retuen the ShareAndRetrictButton click state
//
// This will be used in content type : Whiteboard and Database
// Purpose - to decide if to show a share flag to nudge user to share the content
// if user already click share button in current content, the share nudge will be muted
//
// Usage
// - Whiteboard https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/confluence/next/packages/experiment-share-new-whiteboard/src/useShareNewWhiteboardFlag.tsx
//
// Project poster
// - Whiteboard https://hello.atlassian.net/wiki/spaces/cffd/pages/5161235026/Tech+Spec+-+Prompt+sharing+of+whiteboard+after+creation
// - Database https://hello.atlassian.net/wiki/spaces/cffd/pages/5193390250/Modified+requirements+for+Prompt+Sharing+of+Databases
//
//  */

type ShareAndRestrictButtonState = {
	hasClickedShareButton: boolean;
};
const initialState: ShareAndRestrictButtonState = {
	hasClickedShareButton: false,
};
const actions = {
	setHasClickedShareButton:
		(): Action<ShareAndRestrictButtonState> =>
		({ setState }) => {
			setState({
				hasClickedShareButton: true,
			});
		},
	resetHasClickedShareButton:
		(): Action<ShareAndRestrictButtonState> =>
		({ setState }) => {
			setState({
				hasClickedShareButton: false,
			});
		},
};
const ShareAndRestrictButtonStore = createStore({
	initialState,
	actions,
	name: 'ShareAndRestrictButtonStore',
});
export const useShareAndRestrictButtonState: HookStateFunction<ShareAndRestrictButtonState, void> =
	createStateHook(ShareAndRestrictButtonStore);
export const useShareAndRestrictButtonActions: HookActionsFunction<
	BoundActions<
		ShareAndRestrictButtonState,
		{
			setHasClickedShareButton: () => Action<ShareAndRestrictButtonState>;
			resetHasClickedShareButton: () => Action<ShareAndRestrictButtonState>;
		}
	>
> = createActionsHook(ShareAndRestrictButtonStore);
